import { BaseService } from './../base'
export class RoleService extends BaseService {
    static get entity () {
        return 'role'
    }
    static get name () {
        return 'role'
    }
}